import {
  brandLogo,
  instagramBoutique,
  instagramChristmasWindow,
  instagramDresses,
  instagramFacade,
  instagramSaleWindow,
  instagramVintageWindow,
} from '@/assets/images';

const feed = [
  {
    src: instagramBoutique,
    alt: 'Collage del interior de la boutique Sano en Llíria con el mostrador, perchas de punto y mesas de vaqueros',
    title: 'SANO Moda · Interior de la boutique en Llíria',
  },
  {
    src: instagramVintageWindow,
    alt: 'Fotografía antigua del escaparate de Boutique Sano con maniquíes y el rótulo iluminado',
    title: 'SANO Moda · Nostalgia vintage de la boutique',
  },
  {
    src: instagramChristmasWindow,
    alt: 'Escaparate de la boutique Sano decorado en Navidad con árbol blanco y vestidos de fiesta',
    title: 'SANO Moda · Escaparate de Navidad',
  },
  {
    src: instagramFacade,
    alt: 'Fachada de la boutique Sano iluminada de noche con el rótulo SANO Boutique',
    title: 'SANO Moda · Nuestra fachada en Llíria',
  },
  {
    src: instagramDresses,
    alt: 'Percheros de la boutique Sano con vestidos de fiesta en lentejuelas, encaje y colores intensos',
    title: 'SANO Moda · Nuestra selección de vestidos',
  },
  {
    src: instagramSaleWindow,
    alt: 'Escaparate de la boutique Sano en rebajas con maniquíes de traje, camisa y ropa de hombre',
    title: 'SANO Moda · Escaparate de rebajas',
  },
];

export default function Instagram() {
  return (
    <section className="py-24 md:py-28 bg-cream-100">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="bg-ink-900 px-6 md:px-12 py-12 md:py-16 text-center mb-12 md:mb-14">
          <p className="text-[11px] tracking-widest-xl text-cream-50/45 mb-4">@ROPASANO</p>
          <h2 className="font-display text-4xl md:text-6xl text-cream-50 mb-6 flex items-center justify-center gap-3 md:gap-4">
            <img
              src={brandLogo}
              alt="SANO Moda"
              title="SANO Moda · Llíria, Valencia"
              className="h-7 md:h-11 w-auto brightness-0 invert"
            />
            <span>en Instagram</span>
          </h2>
          <div className="w-16 h-px bg-cream-50/30 mx-auto"></div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4 mb-12">
          {feed.map((post) => (
            <a
              key={post.title}
              href="https://instagram.com/ropasano"
              target="_blank"
              rel="noreferrer"
              className="relative hover-zoom overflow-hidden group cursor-pointer"
            >
              <img
                src={post.src}
                alt={post.alt}
                title={post.title}
                className="w-full aspect-square object-cover object-center"
              />
              <div className="absolute inset-0 group-hover:bg-ink-900/30 transition-colors flex items-center justify-center">
                <i className="ri-instagram-line text-cream-50 text-2xl opacity-0 group-hover:opacity-100 transition-opacity"></i>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://instagram.com/ropasano"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-3 px-9 py-4 border border-ink-900 text-ink-900 text-[11px] tracking-widest hover:bg-ink-900 hover:text-cream-50 transition-all duration-500 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-instagram-line"></i>
            SEGUIRNOS EN INSTAGRAM
          </a>
        </div>
      </div>
    </section>
  );
}